import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260727-mobile",
        datum: "27.07.2026",
        kategorie: KategorieEnum.MOBILGERAETE_APP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Mobile-App v6.1.4",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE, LizenzEnum.FREE],
        content: [
            "<ul>"
            + "<li>⚙️ Helferstunden können jetzt anhand eines Datumsbereichs (von–bis) gefiltert werden.</li>"
            + "<li>👤 Auf der Personalübersicht werden Icons bei Mitgliedern angezeigt, die jünger als 18 bzw. 16 Jahre alt sind. Die Icons werden nur angezeigt, wenn man zuständig für die Disposition der Veranstaltung ist.</li>"
            + "<li>🐞 Anzeigefehler auf Dashboard gefixt: Eingestellten Filteroptionen werden nun bei der Darstellung besser berücksichtigt.</li>"
            + "</ul>",
        ],
        aktions: [],
    },
];

export {
    insights,
};
